import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { useCareersContent } from "../../Pages.hook";
import { fields } from "../../constants";

export const CareersContent = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const { data: editData, error, isLoading: drilldownLoading, isError, refetch: refetchEditData } = useCareersContent();

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    } else {
      refetchEditData();
    }
  }, [query.get("id")]);

  const AwardsFormConfig: FormConfig = {
    initialValues: {
      field_page_title_en: dataById
        ? decodeHTML(dataById.payload.field_page_title_en || "")
        : editData
          ? decodeHTML(editData?.[0]?.field_page_title_en || "")
          : "",

      field_page_title_ms: dataById
        ? decodeHTML(dataById.payload.field_page_title_ms || "")
        : editData
          ? decodeHTML(editData?.[0]?.field_page_title_ms || "")
          : "",

      field_page_title_zh: dataById
        ? decodeHTML(dataById.payload.field_page_title_zh || "")
        : editData
          ? decodeHTML(editData?.[0]?.field_page_title_zh || "")
          : "",

      field_content_description_en: dataById
        ? decodeHTML(dataById.payload.field_content_description_en || "")
        : editData
          ? decodeHTML(editData?.[0]?.field_content_description_en || "")
          : "",

      field_content_description_ms: dataById
        ? decodeHTML(dataById.payload.field_content_description_ms || "")
        : editData
          ? decodeHTML(editData?.[0]?.field_content_description_ms || "")
          : "",

      field_content_description_zh: dataById
        ? decodeHTML(dataById.payload.field_content_description_zh || "")
        : editData
          ? decodeHTML(editData?.[0]?.field_content_description_zh || "")
          : "",

      noVancancyImage: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "noVancancyImage.png",
              status: "done",
              url: dataById?.payload?.noVancancyImage,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "noVancancyImage.png",
              status: "done",
              url: editData?.[0]?.noVancancyImage,
            },
          ]),

      bannerImage: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "bannerImage.png",
              status: "done",
              url: dataById?.payload?.bannerImage,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "bannerImage.png",
              status: "done",
              url: editData?.[0]?.bannerImage,
            },
          ]),
    },
    fields: fields.careersContent,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["bannerImage", "noVancancyImage"];
    for (const key of imageKeys) {
      try {
        let field = data[key];

        if (Array.isArray(field) && field.length > 0) {
          if (field[0].originFileObj) {
            const formData = new FormData();
            formData.append("upload-file", field[0].originFileObj);
            formData.append("application", "ERAMAN");
            const res: any = await post("management/upload-file", formData);

            if (res) {
              data[key] = res.response.data;
            }
          } else {
            data[key] = field[0]?.url || "";
          }
        } else {
          data[key] = ""; // ✅ Set empty string when no image
        }
      } catch (error) {
        data[key] = ""; // ✅ Also set empty string on error
      }
    }

    const payload = {
      action: action,
      method: method,
      module: "Pages",
      subModule: `aboutEraman_careers_careersContent`,
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editData?.[0]?.id || dataById?.payload?.id }),
        ...data,
        published: true,
      },
      status: status,
    };
    console.log(payload, "payload");
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <>
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={AwardsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${eramanHost}/api/page-careers-list-page-crud-api/${editData?.[0]?.id || dataById?.payload?.id}`,
            "UPDATE",
            "PATCH",
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </>
  );
};
